/* eslint-disable @typescript-eslint/no-explicit-any -- store/Api is still
 * untyped JS; pantry rows arrive as opaque objects. Commit to a concrete
 * Pantry[] type once that layer is migrated to TypeScript.
 */
import Api from '../../../store/Api';

import type { Bbox, MapOpts } from './types';

/**
 * Plentiful monolith location adapter. Returns the upstream `/map/locations`
 * response verbatim — no client-side filtering — so the production code path
 * stays as it has always shipped from `app.plentifulapp.com`.
 */
export class PlentifulLocationsService {
  async fetchMapLocations(
    isLoggedIn: boolean,
    bbox: Bbox,
    filter: any,
    opts: MapOpts = {}
  ): Promise<any[]> {
    const rows = await Api.getPantries(
      isLoggedIn,
      bbox.lat1,
      bbox.lng1,
      bbox.lat2,
      bbox.lng2,
      filter,
      opts
    );
    return Array.isArray(rows) ? rows : [];
  }

  fetchLocationById(organizationId: number | string, isLoggedIn: boolean): Promise<any> {
    return Api.getPantryByOrganizationId(organizationId, isLoggedIn);
  }
}

export default PlentifulLocationsService;
